<div class="bg-img-container">
  <div class="container">
    <div class="form">
      <h2>
        {{ 'report.energy' | translate }} {{ 'report.title' | translate }}
      </h2>
      <mat-divider></mat-divider>

      <!-- Energy Tree Excel Report form -->
      <form name="form" (ngSubmit)="f.form.valid && ok()" #f="ngForm">
        <!-- Select Date Range -->
        <div class="row" style="padding-top: 20px">
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
            <mat-label class="label-input"
              >{{ 'report.selectDate' | translate }}
              <span class="iep-required">*</span></mat-label
            >
          </div>
          <div class="row">
            <div class="col-md-4">
              <mat-form-field>
                <input
                  matInput
                  [matDatepicker]="picker1"
                  [formControl]="startDateCtr"
                  placeholder="{{ 'report.fromDate' | translate }}"
                  (dateChange)="validateStartDate()"
                  [max]="max"
                  class="start-date"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker1"
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #picker1
                  startView="month"
                  (yearSelected)="chosenStartDate_YearHandler($event)"
                  (monthSelected)="chosenStartDate_MonthHandler($event)"
                ></mat-datepicker>
                <mat-error *ngIf="startDateCtr.invalid || !isValidStartDate">{{
                  startDateErrorMessage
                }}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field>
                <input
                  matInput
                  [matDatepicker]="picker2"
                  [formControl]="endDateCtr"
                  placeholder="{{ 'report.toDate' | translate }}"
                  (dateChange)="validateEndDate()"
                  [max]="max"
                  class="end-date"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker2"
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #picker2
                  startView="month"
                  (yearSelected)="chosenEndDate_YearHandler($event)"
                  (monthSelected)="chosenEndDate_MonthHandler($event)"
                ></mat-datepicker>
                <mat-error *ngIf="endDateCtr.invalid || !isValidEndDate">{{
                  endDateErrorMessage
                }}</mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- Submit button to get report -->
        <div class="pull-right">
          <button
            class="button-primary"
            id="generate-excel-report"
            bciprimarybutton
            [disabled]="startDateCtr.invalid || endDateCtr.invalid"
          >
            {{ 'report.ok' | translate }}
          </button>
        </div>
      </form>
      <!-- form end -->
    </div>
  </div>
</div>
